'use strict';

import React from 'react';
import UserStore from 'stores/UserStore';
import UserActions from 'actions/UserActions';
import API from 'sources/API';
import AvatarEditor from 'react-avatar-editor'
import {browserHistory} from 'react-router';

require('styles/Setting.scss');

function convertCanvasToImage(canvas){
  //canvas.toDataURL返回的是一串Base64编码的URL
  let url = canvas.toDataURL("image/png");
  return url;
}

class SettingComponent extends React.Component {
  constructor(props) {
    super(props);
    let user = UserStore.getState().user;
    this.state = {
      user: user?user:{},
      avatar: user?user.avatar:'',
      gender: user?user.gender:'',
      name: user?user.name:'',
      weibo: user?(user.weibo||''):'',
      tel: user?(user.tel||''):'',
      location: user?user.location:'',
      website: user?(user.website||''):'',
      wechat_name: user?(user.wechat_name||''):'',
      summary: user?user.summary:'',
      localAvatar: user?user.avatar:'',
      avatarUploading: false,
      cropperOpen: false,
      fileName: null
    };
    this.onUserChange = this.onUserChange.bind(this);
    this.onTextChange = this.onTextChange.bind(this);
    this.onSave = this.onSave.bind(this);
    this.onLogout = this.onLogout.bind(this);
    this.onGenderChange = this.onGenderChange.bind(this);
    this.picUpload = this.picUpload.bind(this);
    this.handleCrop = this.handleCrop.bind(this);
  }
  handleCrop() {
    if (this.editor) {
      const canvasScaled = this.editor.getImageScaledToCanvas()
      this.setState({
        avatar: convertCanvasToImage(canvasScaled),
        cropperOpen: false,
        avatarUploading: true
      })
      canvasScaled.toBlob((blob) => {
        let formData = new FormData();
          formData.append('file', blob, this.state.fileName);
          fetch(`${API.postAvatar}`, {
            method: 'POST',
            body: formData
          }).then(res=>res.json())
          .then(json=>{
            if(json.status === 0) {
              this.setState({
                  avatarUploading: false
              });
            }
          });
      })
    }
  }
  componentDidMount() {
    UserStore.listen(this.onUserChange);
    UserActions.fetchUser();

    window.scrollTo(0,0);

    // Baidu tongji
    window._hmt.push(['_trackPageview', this.props.location.pathname]);
  }
  componentWillUnmount() {
    UserStore.unlisten(this.onUserChange);
  }
  onUserChange(state) {
    let user = state.user;
    if(user){
      this.setState({
        user: user?user:{},
        avatar: user?user.avatar:'',
        gender: user?user.gender:'',
        name: user?user.name:'',
        weibo: user?(user.weibo||''):'',
        tel: user?(user.tel||''):'',
        location: user?user.location:'',
        website: user?(user.website||''):'',
        wechat_name: user?(user.wechat_name||''):'',
        summary: user?user.summary:'',
        localAvatar: user?user.avatar:''
      });
    }
  }
  onGenderChange(e) {
    this.setState({gender: e.target.value});
  }
  onTextChange(e) {
    let name = e.target.name;
    let val = e.target.value;
    if(name === 'name' && val.length >= 10) {
      val = val.slice(0,10);
    }
    if(name === 'summary' && val.length >= 140) {
      val = val.slice(0,140);
    }
    let newState = {};
    newState[name] = val;
    this.setState(newState);
  }
  onSave() {
    UserActions.postUserInfo({
      gender: this.state.gender,
      name: this.state.name,
      location: this.state.location,
      website: this.state.website,
      summary: this.state.summary,
      weibo: this.state.weibo,
      tel: this.state.tel,
      wechat_name: this.state.wechat_name,
      accessToken: UserStore.getState().accessToken
    });
  }
  onLogout() {
    UserActions.updateToken(null);
    browserHistory.push('/medias');
  }
  picUpload(e) {
    let reader = new FileReader();
    let file = e.target.files[0];
    if (!file) return;
    let that = this;
    reader.onload = function(img) {
      that.setState({
        localAvatar: img.target.result,
        cropperOpen: true,
        fileName: file.name
      });
    };
    reader.readAsDataURL(file);
  }
  setEditorRef = (editor) => this.editor = editor
  render() {
    return (
      <div className="setting-component">
        <div className="row header text-center">
          <a className="float-left text-white ml-20" onClick={browserHistory.goBack}>返回</a>
          设置
          <a className="float-right text-white mr-20" onClick={this.onSave}>保存</a>
        </div>
        <div className={this.state.cropperOpen?"avatar-cropper-wrap open":"avatar-cropper-wrap"}>
          <AvatarEditor
            ref={this.setEditorRef}
            image={this.state.localAvatar}
            width={250}
            height={250}
            borderRadius={125}
            border={0}
            scale={1.5}
            rotate={0}
          />
          <div className="confirm-wrap"><button className="button expanded" onClick={this.handleCrop}>确认</button></div>
        </div>
        <div className="row bg-white border mb-15">
          <div className="columns pt-10 pb-10 pl-20 pr-20">
            <label className="float-left fz-18 middle mb-0">头像</label>
            <img className="avatar float-right contain" src={this.state.avatar} />
            <input className={this.state.avatarUploading ? 'avatar-input uploading' : 'avatar-input'} onChange={this.picUpload} type="file" name="pic" />
          </div>
        </div>
        <div className="row bg-white border mb-15">
          <fieldset className="columns pt-10 pl-20 pr-20">
            <legend className="pt-10 fz-18">性别</legend>
            <label className="pull-left mr-50">男
              <input className="ml-10" type="radio" name="gender" value="0" checked={ this.state.gender == 0 } onChange={this.onGenderChange} />
            </label>
            <label className="pull-left">女
              <input className="ml-10" type="radio" name="gender" value="1" checked={ this.state.gender == 1 } onChange={this.onGenderChange} />
            </label>
          </fieldset>
        </div>
        <div className="row bg-white border mb-15">
          <div className="columns pt-10 pl-20 pr-20">
            <label className="fz-18">昵称：</label>
            <input type="text" className="mb-5" value={this.state.name} name='name' onChange={this.onTextChange} />
            <p className="help-text">{this.state.name.length}/10</p>
          </div>
        </div>
        <div className="row bg-white border mb-15">
          <div className="columns pt-10 pl-20 pr-20">
            <label className="fz-18">位置：</label>
            <input type="text" value={this.state.location} name="location" onChange={this.onTextChange} />
          </div>
        </div>
        <div className="row bg-white border mb-15">
          <div className="columns pt-10 pl-20 pr-20">
            <label className="fz-18">个人网址：</label>
            <input type="text" value={this.state.website} name="website" onChange={this.onTextChange} />
          </div>
        </div>
         <div className="row bg-white border mb-15">
          <div className="columns pt-10 pl-20 pr-20">
            <label className="fz-18">微博：</label>
            <input type="text" value={this.state.weibo} name="weibo" onChange={this.onTextChange} />
          </div>
        </div>
         <div className="row bg-white border mb-15">
          <div className="columns pt-10 pl-20 pr-20">
            <label className="fz-18">微信：</label>
            <input type="text" value={this.state.wechat_name} name="wechat_name" onChange={this.onTextChange} />
          </div>
        </div>
         <div className="row bg-white border mb-15">
          <div className="columns pt-10 pl-20 pr-20">
            <label className="fz-18">电话：</label>
            <input type="text" value={this.state.tel} name="tel" onChange={this.onTextChange} />
          </div>
        </div>
        <div className="row bg-white border mb-15">
          <div className="columns pt-10 pl-20 pr-20">
            <label className="fz-18">简介：</label>
            <textarea placeholder="写点什么吧" value={this.state.summary} name="summary" onChange={this.onTextChange}></textarea>
            <p className="help-text mt-0">{this.state.summary.length}/140</p>
          </div>
        </div>
        <div className='row'>
          <div className="columns pl-20 pr-20 hide">
            <button className="button expanded fz-14" onClick={this.onSave}>保存</button>
          </div>
          <div className="columns pl-20 pr-20">
            <button className="button expanded fz-14" onClick={this.onLogout}>退出</button>
          </div>
        </div>
      </div>
    );
  }
}

SettingComponent.displayName = 'SettingComponent';

export default SettingComponent;



// WEBPACK FOOTER //
// ./src/components/SettingComponent.js